import { render, staticRenderFns } from "./centered-recommend.vue?vue&type=template&id=77294d34&scoped=true"
import script from "./centered-recommend.vue?vue&type=script&lang=js"
export * from "./centered-recommend.vue?vue&type=script&lang=js"
import style0 from "./centered-recommend.vue?vue&type=style&index=0&id=77294d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77294d34",
  null
  
)

export default component.exports